// layout
import AuthPortalLayout from '../../layouts/auth/AuthPortalLayout';
import { AUTH_PORTALS } from '../../layouts/auth/portals';
// sections
import { LoginForm } from '../../sections/auth/login';

// ----------------------------------------------------------------------
// No "Don't have an account? Get started" here. The intranet is invite-only:
// staff accounts are created by an admin (addUser), which provisions the
// Supabase identity. Offering a sign-up link invited people to try something
// that is not theirs to do.
//
// Two ways in since 2026-10-11 — the team's Microsoft account and the email
// and password — and the line under the title names both, so neither reads
// as the fallback for the other.
// ----------------------------------------------------------------------

export const INTRANET_SIGN_IN = {
  title: 'Sign in to Intranet',
  subtitle:
    'Use your LingoYou Microsoft account or your work email and password.'
};

export default function Login() {
  return (
    <AuthPortalLayout
      portal={AUTH_PORTALS.intranet}
      title={INTRANET_SIGN_IN.title}
      subtitle={INTRANET_SIGN_IN.subtitle}
    >
      <LoginForm />
    </AuthPortalLayout>
  );
}
